import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ParcelSalesService {
  private _showFormSalesData: boolean = false;
  private _saleCode: string = '';

  setShowFormSalesData(showForm: boolean){
    this._showFormSalesData = showForm;
  }
  get showFormSalesData(): boolean{
    return this._showFormSalesData;
  }

  setSaleCode(code: string){
    this._saleCode = code;
  }

  get saleCode(): string{
    return this._saleCode;
  }
}
